import { LazyTreeView } from '@assets/js/components/tree-view-structure.js';

import {
	onPageLoaded,
	pubsub
} from '@assets/js/imaios-global/imaios-global';
import { getSiteAccess } from '@imaios-js/utils';
import { TREE_VIEW_NOTIFICATIONS } from './notifications';
import {
	getOriginTaFromUrl,
	selectTerminologyFromLocation
} from '@templates/components/structures/select-ta';

const TREE_VIEW_SELECTOR = '#tree-view-listing-ta > ul > li';

onPageLoaded(async () => {
	let currentTaId = null;
	const siteaccess = getSiteAccess();
	const treeViewTaListing = document.getElementById('tree-view-listing-ta');
	const allTreeViewListingTaLI = document.querySelectorAll('.tree-view-listing-ta ul li');

	pubsub.subscribe(
		pubsub,
		TREE_VIEW_NOTIFICATIONS.CURRENT_TA_CHANGE,
		function (taId) {
			currentTaId = taId;
		}
	);

	function displayTree(taId) {
		document
			.querySelectorAll('.init-tree')
			.forEach(element => element.classList.add('d-none'));
		document
			.querySelectorAll('.init-tree-' + taId)
			.forEach(element => element.classList.remove('d-none'));
	}

	function displayTitleAnatomy(idElemToDisplay) {
		document
			.querySelectorAll('.tree-view-title')
			.forEach(element => element.classList.add('d-none'));

		document
			.getElementById(idElemToDisplay)
			.classList.remove('d-none');
	}

	function displayCheckingLI(taId) {
		const selectedTreeViewListingTaLI = document.querySelector(
			'.tree-view-listing-ta ul li[data-attr-ta=\'' + taId + '\']'
		);
		allTreeViewListingTaLI.forEach(element => {
			element.classList.remove('active');
			element.children[0].classList.add('d-none');
		});
		selectedTreeViewListingTaLI.classList.add('active');
		selectedTreeViewListingTaLI.children[0].classList.remove('d-none');
	}

	function listenerDocument(event) {
		const isClickInsideElement = treeViewTaListing.contains(event.target);
		if (!isClickInsideElement) {
			treeViewTaListing.classList.add('d-none');
			displayCloseButton(currentTaId);
		}

		document.removeEventListener('click', listenerDocument);
	}

	function displayOpenButton(taId) {
		document
			.getElementById('tree-view-title-open-' + taId)
			?.classList.remove('d-none');

		document
			.getElementById('tree-view-title-close-' + taId)
			?.classList.add('d-none');
	}

	function displayCloseButton(taId) {
		document
			.getElementById('tree-view-title-open-' + taId)
			?.classList.add('d-none');
		document
			.getElementById('tree-view-title-close-' + taId)
			?.classList.remove('d-none');
	}

	document
		.querySelectorAll('.tree-view-title-close')
		.forEach(element =>
			element.addEventListener('click', event => {
				// hide list of Taxonomy
				const taId = element.getAttribute('data-attr-ta');
				pubsub.publish(TREE_VIEW_NOTIFICATIONS.CURRENT_TA_CHANGE, taId);

				treeViewTaListing.classList.remove('d-none');

				event.stopPropagation(); // able to not active the click directly for listener document bellow
				event.stopImmediatePropagation();

				displayOpenButton(taId);
				document.addEventListener('click', listenerDocument);
			})
		);

	document
		.querySelectorAll('.tree-view-title-open')
		.forEach(element =>
			element.addEventListener('click', event => {
				// hide list of Taxonomy
				const taId = element.getAttribute('data-attr-ta');
				pubsub.publish(TREE_VIEW_NOTIFICATIONS.CURRENT_TA_CHANGE, taId);

				treeViewTaListing.classList.add('d-none');

				event.stopPropagation(); // able to not active the click directly for listener document bellow
				event.stopImmediatePropagation();

				displayCloseButton(taId);
				document.removeEventListener('click', listenerDocument);
			}));

	allTreeViewListingTaLI.forEach(element => {
		element.addEventListener('click', () => {
			const taId = element.getAttribute('data-attr-ta');
			pubsub.publish(TREE_VIEW_NOTIFICATIONS.CURRENT_TA_CHANGE, taId);

			treeViewTaListing.classList.add('d-none');

			displayTitleAnatomy('tree-view-title-' + taId);
			displayTree(taId);
			displayCheckingLI(taId);
			displayCloseButton(taId);
		});
	});


	document
		.querySelectorAll('.init-tree')
		.forEach(container => {
			const rootId = container.getAttribute('data-attr-root-id');
			const rootData = container.getAttribute('data-attr-root-tree');
			const taId = container.getAttribute('data-attr-ta');
			const rootTree = JSON.parse(rootData)[0];

			LazyTreeView.generate({
				rootId, // correspond to the hash of current taxon on page structure
				container,
				rootTree,
				endpoints: {
					getChildren: `/${siteaccess}/api/anatomy/treeview/children/${taId}`
				}
			});
		});

	let lastX = 0;
	let delta = 0;
	let done = false;
	const sidebar = document.querySelector('.structure-tree-view-container');
	const dragholder = document.querySelector('.dragholder');
	const maxContentHeight = document.querySelector('.page-layout');
	const SVGCloseMobile = document.getElementById('closeSvgMobileSearch');

	pubsub.subscribe(
		pubsub,
		TREE_VIEW_NOTIFICATIONS.UPDATE_MOBILE_STRUCTURE,
		(payload) => document.querySelectorAll('.mobile-override-js')
			.forEach(e => {
				if (payload.active) {
					e.classList.add('mobile-structure');
				}
				else {
					e.classList.remove('mobile-structure');
				}
			})
	);

	function getPageX(event) {
		if (event.touches) {
			return event.touches[0].pageX;
		}
		return event.pageX;
	}

	function onInteractionPerform(event) {
		const pageX = getPageX(event);

		delta += pageX - lastX;
		lastX = pageX;
		pubsub.publish(TREE_VIEW_NOTIFICATIONS.DRAGHOLDER_MOUSE_MOVE);
	}

	function onInteractionStart(event) {
		done = false;
		lastX = getPageX(event);
		document.addEventListener('mousemove', onInteractionPerform);
		document.addEventListener('touchmove', onInteractionPerform);
		window.requestAnimationFrame(refreshSidebarSize);
	}

	function onInteractionEnd() {
		done = true;
		document.removeEventListener('mousemove', onInteractionPerform);
		document.removeEventListener('touchmove', onInteractionPerform);
		pubsub.publish(TREE_VIEW_NOTIFICATIONS.DRAGHOLDER_MOUSE_UP);
	}

	function resetViewportSize() {
		sidebar.style.width = null;
	}

	function setMaxContentHeight() {
		maxContentHeight.style.minHeight = maxContentHeight.offsetHeight + 'px';
	}

	function refreshSidebarSize() {
		if (delta < 0) {
			if (lastX < sidebar.getBoundingClientRect().right) {
				sidebar.style.width = (sidebar.offsetWidth + delta) + 'px';
			}
		}
		else {
			sidebar.style.width = (sidebar.offsetWidth + delta) + 'px';
		}
		delta = 0;
		if (!done) {
			window.requestAnimationFrame(refreshSidebarSize);
		}
	}

	window.onresize = resetViewportSize;
	window.addEventListener('load', setMaxContentHeight);
	document.addEventListener('mouseup', onInteractionEnd);

	dragholder.addEventListener('mousedown', onInteractionStart);
	dragholder.addEventListener('mouseup', onInteractionEnd);

	dragholder.addEventListener('touchstart', onInteractionStart);
	dragholder.addEventListener('touchend', onInteractionEnd);

	SVGCloseMobile.addEventListener('click', () => pubsub.publish(TREE_VIEW_NOTIFICATIONS.CLOSE_SVG_MOBILE_SEARCH));

	void selectTerminologyFromLocation(`${TREE_VIEW_SELECTOR}[data-attr-ta="${parseInt(getOriginTaFromUrl())}"]`);
});
